import * as React from 'react';
import { Label } from '../../../../ui/label/label';
import { PikDropdown } from '../../../../ui/pik_dropdown/pik_dropdown';
import { Region } from '../../../../utils/regions';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/redux';
import { regionChange } from '../../../../actions/filter';

interface IRegionValue {
  label: string;
  value: Region;
}

interface IStateProps {
  region: Region;
  regions: IRegionValue[];
}

interface IInteractionsProps {
  setRegion(region: Region): void;
}

export class RegionComponent extends React.PureComponent<IStateProps & IInteractionsProps, object> {
  public render() {
    return (
      <Label text="Регион:">
        <PikDropdown value={this.props.region} onValueChange={this.props.setRegion} values={this.props.regions} />
      </Label>
    );
  }
}

export const RegionField = connect(
  (state: IApplicationState) => ({
    region: typeof state.filter.query.region === 'number' ? 'moscow' : state.filter.query.region,
    regions: state.locations
      .filter(location => location.jkCount > 0)
      .map((location): IRegionValue => ({ label: location.name, value: location.linkId })),
    tabs: state.tabs,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      setRegion: (value: Region) => {
        dispatch(regionChange(value));
      },
    };
  },
)(RegionComponent);
